// 采集相关阈值配置，避免在代码中硬编码

/**
 * 到达该采集数量阈值时，显示「选择画板」逻辑的边界
 * 例如：采集数 < SELECT_BOARD_PIN_COUNT_THRESHOLD 则隐藏；
 *       === SELECT_BOARD_PIN_COUNT_THRESHOLD 则强制显示
 */
export const SELECT_BOARD_PIN_COUNT_THRESHOLD = 5;

/**
 * 用户画板数量达到该阈值时，不再进行推荐画板（只显示最近画板）
 */
export const USER_BOARD_RECOMMEND_THRESHOLD = 5;
